let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jOxHJ")).then(() => parcelRequire('2wBQ6'));